export default "__VITE_ASSET__D_PhxciE__"